<template>
  <v-col
    sm="10"
    xl="11"
    class="pa-1 pl-0"
  >
    <v-row dense>
      <v-col
        v-for="button in visibleButtons"
        :key="button.key"
        cols="6"
        class="px-1 py-0"
      >
        <chat-insert-template-button
          :label="button.label"
          :icon="button.icon"
          :disabled="messageDisabled"
          @click="button.action"
        />
      </v-col>
    </v-row>
  </v-col>
</template>

<script setup>
import { computed } from "vue";
import ChatInsertTemplateButton from "./ChatInsertTemplateButton.vue";

const props = defineProps({
  logType: {
    type: String,
    required: true
  },
  messageDisabled: {
    type: Boolean,
    required: true
  },
  lineUrl: {
    type: String,
    default: ""
  },
  epdsUrl: {
    type: String,
    default: ""
  },
  doctorName: {
    type: String,
    default: ""
  },
  doctorProfileUrl: {
    type: String,
    default: ""
  },
  departmentType: {
    type: Number,
    required: true
  }
});

const emit = defineEmits(["insert-template"]);

function inviteCalling() {
  let fixedPhrase = "通話での相談をご希望ですね。\n";
  fixedPhrase += "下記のリンクをクリックすると通話を開始できます。\n";
  fixedPhrase += "クリックしていただけますか？\n";
  fixedPhrase += props.lineUrl;
  fixedPhrase += "\n";
  fixedPhrase += "※ビデオ通話をご希望の場合、通話開始後、カメラマークをクリックして、ビデオをONにしてください。\n";
  fixedPhrase += "※音声通話をご希望の場合は、URLをクリックするだけで開始できます。";
  emit("insert-template", fixedPhrase);
}

function requestSurvey() {
  const fixedPhrase = "産婦人科・小児科オンラインのサービスをご利用いただきありがとうございました。\n明日、簡単なアンケートをお送りさせていただきます。その後の様子をお伺いできれば私たちも安心ですし、今後のサービス改善にもつなげていきたいので、ぜひご協力をお願いいたします。\nまたいつでもご利用ください。どうぞお大事にしてくださいね。";
  emit("insert-template", fixedPhrase);
}

function sendEPDS() {
  let fixedPhrase = "産後はどの時期も体と心の疲労が溜まりやすい時期ですので、みなさんにアンケートとしてお願いしております。今のご自身の気持ちを振り返ってみましょう。\n";
  fixedPhrase += "ぜひ下記URLより回答してみてくださいね。\n\n";
  fixedPhrase += props.epdsUrl;
  emit("insert-template", fixedPhrase);
}

function getServiceName() {
  return props.departmentType === 1 ? "小児科オンライン" : "産婦人科オンライン";
}

function getDoctorTitle() {
  switch (props.departmentType) {
  case 1:
    return "小児科医";
  case 2:
    return "産婦人科医";
  case 3:
    return "助産師";
  default:
    return "";
  }
}

function sendKarteStartGreeting() {
  let fixedPhrase = `本日は${getServiceName()}のサービスをご利用いただきありがとうございます。\n`;
  fixedPhrase += `本日担当します${getDoctorTitle()}の${props.doctorName}です。\n`;
  fixedPhrase += "どうぞ、よろしくお願いいたします。";
  emit("insert-template", fixedPhrase);
}

// 日中助産師相談（logType: daytimeAdvice）の開始/終了挨拶・EPDS送信は
// Chat.vue側のchat-user-label内クイックアクションで提供しており、
// ChatInsert自体がisDaytimeAdvice時には表示されないためここでは扱わない。

const templateButtons = [
  { key: "karteStartGreeting", label: "開始挨拶", icon: "mdi-hand-right", action: sendKarteStartGreeting, logTypes: ["karte"] },
  { key: "survey", label: "アンケート", icon: "mdi-clipboard-text", action: requestSurvey, logTypes: ["karte"] },
  { key: "calling", label: "通話誘導", icon: "mdi-phone", action: inviteCalling, logTypes: ["karte"] },
  { key: "epds", label: "EPDS", icon: "mdi-heart", action: sendEPDS, logTypes: ["karte"] }
];

const visibleButtons = computed(() => {
  return templateButtons.filter(button => button.logTypes.includes(props.logType));
});
</script>
